import { useEffect, useState } from 'react';
import axios from 'axios';

import { publicDataDomain } from '../../../util/config';

interface UseFetchPlaylistDataProps {
	playlistId: string;
	accountId: string;
}
const useFetchPlaylistData = ({ playlistId, accountId }: UseFetchPlaylistDataProps) => {
	const [playlistData, setPlaylistData] = useState<any>();

	useEffect(() => {
		if (!playlistId || !accountId) {
			return;
		}

		const url = publicDataDomain + accountId + '/playlists/' + playlistId;
		axios.get(url).then((response) => {
			const data = response?.data;
			const medias = data?.medias ?? [];

			if (medias.length > 0) {
				medias.sort((itemA: any, itemB: any) => {
					return itemA.order - itemB.order;
				});
				setPlaylistData(data);
				return;
			}

			// A dynamic playlist holds no medias of its own - the playlist resource comes back without
			// a `medias` key at all, and its contents only exist once the query behind it is resolved.
			// `/medias?followRedirects=true` is what resolves it, and is the very URL GoBrain is handed
			// for a normal playlist preset; that is why those render a dynamic playlist while the Story
			// path, which reads `medias` off the playlist, rendered an empty feed.
			// Wrapped back into the `{ order, item }` shape so callers see one shape for both kinds.
			axios
				.get(url + '/medias?followRedirects=true')
				.then((mediasResponse) => {
					const resolved = Array.isArray(mediasResponse?.data) ? mediasResponse.data : [];
					setPlaylistData({ ...data, medias: resolved.map((item: any, order: number) => ({ order, item })) });
				})
				.catch(() => setPlaylistData(data));
		});
	}, [playlistId, accountId]);

	return playlistData;
};

export default useFetchPlaylistData;
